import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { brand } from "../theme/theme";

/** Barra + porcentaje del setup técnico: gradiente de marca, verde si está completado. */
export const SetupProgress = ({ value = 0, completed = false, sx = {} }) => {
  const theme = useTheme();
  const percent = Math.min(Math.max(Math.round(value || 0), 0), 100);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 140, ...sx }}>
      <Box
        sx={{
          flex: 1,
          height: 6,
          borderRadius: 999,
          backgroundColor: theme.palette.divider,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: `${percent}%`,
            height: "100%",
            borderRadius: 999,
            background: completed ? theme.palette.success.main : brand.gradient,
          }}
        />
      </Box>
      <Typography
        sx={{
          fontSize: "0.75rem",
          fontWeight: 600,
          color: completed ? "success.dark" : "text.secondary",
          minWidth: 34,
          textAlign: "right",
        }}
      >
        {percent}%
      </Typography>
    </Box>
  );
};

SetupProgress.propTypes = {
  value: PropTypes.number,
  completed: PropTypes.bool,
  sx: PropTypes.object,
};
